<mat-card class="calendario-compartilhado">
  <div class="calendario-navegacao">
    <button mat-icon-button type="button" aria-label="Mês anterior" (click)="mudarMes.emit(-1)">
      <mat-icon>chevron_left</mat-icon>
    </button>
    <h3>{{ titulo }}</h3>
    <button mat-icon-button type="button" aria-label="Próximo mês" (click)="mudarMes.emit(1)">
      <mat-icon>chevron_right</mat-icon>
    </button>
  </div>
  <div class="calendario-grade" role="grid" [attr.aria-label]="titulo">
    <div class="calendario-dia-semana" *ngFor="let diaSemana of diasDaSemana">{{ diaSemana }}</div>
    <ng-content></ng-content>
  </div>
</mat-card>